<template>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalTitle">Add new Category</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        
        <form method="post">
            <div class="form-group">
                <label for="name">Categoty Name</label>
                <input  v-model="form.name" type="text" class="form-control" id="name" placeholder="Category Name">
                <small v-if="error || nameError" class="errorMessage">{{nmERR}}{{errors.name}}</small>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="ml-auto mr-auto">
                        <img :src="form.image" class="" style="width: 200px;">
                      </div>
                </div>
            </div>



            <div class="form-group">
                <label for="img">Category Image</label>
                <input type="file" @change="getImage" class="form-control-file" id="img" accept="image/*"/>
                <small v-if="fileError" class="errorMessage">Please upload an image.</small>
            </div>
        </form>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button v-if="form.id == 0" type="button" class="btn btn-primary" @click="addcat">Add Category</button>
        <button v-if="form.id != 0" type="button" class="btn btn-primary" @click="addcat">Update Category</button>
      </div>
    </div>
  </div>
  <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
            Loading
        },
  props:{
      form:Object,
  },
    data(){
      return{
        fullPage:true,
        error: false,
        nmERR:'Please enter a category name.',
        errors: {},
        nameError:false,
        fileError:false,
        isLoading:false,
        
      }
    },
    methods:{
      editC(){
        if(this.form.id != 0 ){
          this.form.hasEdit = 1;
        }
      },
      getImage(e) {

                this.editC();
                this.isLoading = true;
                var file = e.target.files[0];
                var reader = new FileReader();
                if (file['size'] < 4111775) {
                    if (file['type'] == 'image/png' || file['type'] == 'image/jpg' || file['type'] == 'image/jpeg') {
                        reader.onloadend = () => {
                            // console.log('Result', reader.result)
                            this.form.image = reader.result;
                            this.isLoading = false;
                        }

                        reader.readAsDataURL(file);
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: 'Ooops...',
                            text: 'Only images are allowed',
                        })
                        this.isLoading = false;
                    }

                } else {
                    this.$swal({
                        icon: 'error',
                        title: 'Ooops...',
                        text: 'You are uploading a large file',
                    })
                    this.isLoading = false;
                }

            },
      addcat(){
        
        this.nmERR = 'Please enter a category name.';
        this.error = false;
        this.fileError = false;
        this.nameError = false;
        if(this.form.name == '' || this.form.image == ''){
          if(this.form.name == ''){
            this.nameError = true;
          }else if(this.form.image == ''){
            this.fileError = true;
          }
        }else{
        this.isLoading = true;
        
        if(this.form.id == 0){
        this.axios.post('/admin/shopLocal/category', this.form)
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'Category Updated',
                        })
         $('#exampleModal').modal('hide');
         $('#img').val('');
         this.form.image = '';
         this.form.name = '';
         this.$emit("reload");
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.nmERR = '';
          this.errors = resp.response.data.errors;
        
        })
        }else if(this.form.hasEdit == 0 && this.form.id !=0){
        this.axios.patch('/admin/shopLocal/category/' + this.form.id, {name:this.form.name})
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'Category Updated',
                        })
         $('#exampleModal').modal('hide');
         $('#img').val('');
         this.form.image = '';
         this.form.name = '';
         this.$emit("reload");
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.nmERR = '';
          this.errors = resp.response.data.errors;
        
        })
        
        }else if(this.form.hasEdit == 1){
        this.axios.patch('/admin/shopLocal/category/' + this.form.id, this.form)
        .then(()=>{
          this.isLoading = false;
          this.$swal({
                icon: 'success',
                title: 'Hurray',
                text: 'New category created',
                        })
         $('#exampleModal').modal('hide');
         $('#img').val('');
         this.form.image = '';
         this.form.name = '';
         this.$emit("reload");
        })
        .catch((resp)=>{
          this.isLoading = false;
          this.error = true;
          this.nmERR = '';
          this.errors = resp.response.data.errors;
        
        })
        
        }
        }
       
        
      }
    }
}
</script>
<style scoped>
  .errorMessage{
    color: red;
  }
</style>